<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot="menuLeft">
                <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('同好会活动报名', '姓名、工号、手机号、身份证号、部门、Group', defaultParams)">导出Excel
                </el-button>
            </template>
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    name: 'CamerataActivityUser',
    props: ['defaultParams'],
    data() {
      return {
        url: '/camerata/activity/user',
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增同好会', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          delBtnText: '取消报名', // 删除按钮文案
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '员工姓名',
              prop: 'user-username',
              span: 24,
            },
            {
              label: '工号',
              prop: 'user_id',
              span: 24,
            },
            {
              label: '所属部门',
              prop: 'user-class',
              span: 24,
            },
            {
              label: '员工手机号',
              prop: 'user-tel',
              span: 24,
            },
          ]
        }
      }
    },
    methods: {
      // 导出Excel文件统一处理
      excelExport(filename = new Date().getTime(), field, item) {
        console.log(item);
        this.$confirm('导出将由服务器后端执行，需要时间等待，完成后会在右上角提示下载，该导出包含以下内容: ' + field, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const message = this.$notify({
            title: '通知',
            message: '服务器处理中...',
            showClose: false,
            duration: 0
          });
          this.api.get(this.url + '/export?filename=' + filename + '&id='+item.camerataActivityId, this.searchParams).then((re) => {
            message.close()
            if (re.code === 0) {
              let url = this.config.baseURL + '/excel/download/' + re.data;
              this.$notify({
                title: '导出成功!',
                dangerouslyUseHTMLString: true,
                type: 'success',
                duration: 0, // 不会自动关闭的消息
                message: filename + '数据导出完成 下载导出文件:<a target="_blank" href="' + url + '">下载' + filename + 'Excel</a>'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });
        });
      },
    }
  }
</script>
